import React from "react";

import BaseAdmin from "./BaseAdmin"
import EditUserForm from "../../Components/Users/EditUserForm"
import {} from "antd"


class EditUser extends React.Component {

render (){

    return (
        <BaseAdmin
            title="Editar usuario"
            selected="edit-user"
        >
            <EditUserForm user_id={this.props.match.params.id} />
        </BaseAdmin>
        );
    }
}

export default EditUser;
